import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'currency-rubel', 'CurrencyRubel', [["path",{"d":"M8 19v-14h6a3 3 0 0 1 0 6h-8"}],["path",{"d":"M14 15h-8"}]]);